import * as yup from 'yup';
import { DUMMY } from '../const/dummy';

const dummyIds = DUMMY.map(({ id }) => id);

export const formSchema = yup.object({
  receptionNumber: yup.mixed().oneOf(dummyIds, '診察券番号が正しくありません').required('診察券番号が正しくありません')
});

export type FormFields = yup.InferType<typeof formSchema>;
